<div *ngIf="guiSettings.filter" class="m-portlet">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text" i18n="@@5f59d421d1fa4fdb2c8a5eff99314ba06c4df8b2">Prikaz</h3>
            </div>
        </div>
        <div class="m-portlet__head-tools">
            <ul class="m-portlet__nav">
                <li class="m-portlet__nav-item">
                    <div (click)="hiddeDisplaySettings()" class="m-portlet__nav-link m-portlet__nav-link--icon mf-collapse-button">
                        <i
                            class="la"
                            [ngClass]="{
                                'la-angle-down': guiSettings?.filter?.visible,
                                'la-angle-up': !guiSettings?.filter?.visible
                            }"
                        ></i>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div *ngIf="guiSettings?.filter?.visible" class="m-portlet__body">
        <div class="mb-2 d-flex">
            <div *ngIf="customerSearchType === 'LIST'" class="w-100">
                <ng-select
                    #customersearch
                    [items]="customerSearchResult | async"
                    [typeahead]="searchInput"
                    [appendTo]="'body'"
                    (change)="selectCustomer($event)"
                    (clear)="clearSearch()"
                    bindLabel="name"
                    bindValue="name"
                    groupBy="type"
                >
                    <ng-template ng-label-tmp let-item="item">
                        <strong>
                            {{ item?.name }}
                            {{ item?.surname }}
                        </strong>
                        {{ item?.address }}
                        {{ item?.post }}
                        {{ item?.city }}
                        {{ item?.postBox }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        <strong>
                            {{ item?.name }}
                            {{ item?.surname }}
                        </strong>
                        <br />
                        {{ item?.address }}
                        {{ item?.post }}
                        {{ item?.city }}
                        {{ item?.postBox }}
                    </ng-template>
                </ng-select>
            </div>

            <input
                *ngIf="customerSearchType === 'CALENDAR'"
                [ngModel]="searchCustomer"
                (ngModelChange)="searchCalendar($event)"
                type="text"
                placeholder="Išči stranko"
                class="form-control"
            />
            <div *ngIf="searchCustomer" class="pl-1">
                <a
                    (click)="searchCalendar(undefined)"
                    href="#"
                    openDelay="200"
                    ngbTooltip="Počisti iskalni niz"
                    container="body"
                    class="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
                >
                    <i class="la la-times"></i>
                </a>
            </div>
            <div *ngIf="!searchCustomer && !selectedCustomer" class="pl-1">
                <a
                    (click)="changeCustomerSearchType()"
                    href="#"
                    openDelay="200"
                    ngbTooltip="Spremeni način iskanja"
                    container="body"
                    class="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
                >
                    <i
                        class="la"
                        [ngClass]="{
                            'la-calendar': customerSearchType === 'CALENDAR',
                            'la-th-list': customerSearchType === 'LIST'
                        }"
                    ></i>
                </a>
            </div>
        </div>

        <div class="mf-resource-view">
            <label class="m-checkbox">
                <input
                    [checked]="guiSettings.filter.showResources"
                    (change)="onChangeShowResources()"
                    type="checkbox"
                    i18n="@@a436ee68-d8b2-5b9f-b72d-050830fb6de8"
                />
                Prikaži razpoložljivost
                <span></span>
            </label>
            <div *ngIf="guiSettings.filter.showResources" class="ml-4">
                <label class="m-checkbox">
                    <input
                        [checked]="guiSettings.filter.showOnlyAvailable"
                        (change)="onChangeShowAvailable()"
                        type="checkbox"
                        i18n="@@5c403875-b021-55f6-a26c-43c1c82328eb"
                    />
                    Prikaži samo razpoložljive podizvajalce
                    <span></span>
                </label>
                <label *ngIf="isCaseModuleActive" class="m-checkbox">
                    <input
                        [checked]="!guiSettings.filter.showExternalAvailable"
                        (change)="onChangeShowExternalAvailable('external')"
                        type="checkbox"
                        i18n="@@7107423204540416"
                    />
                    Prikaži zunanjo razpoložljivost (partnerji)
                    <span></span>
                </label>
                <label *ngIf="isPatientAppModuleActive" class="m-checkbox">
                    <input
                        [checked]="!guiSettings.filter.showExternalCustomerAvailable"
                        (change)="onChangeShowExternalAvailable('customer')"
                        type="checkbox"
                        i18n="@@4996225814233088"
                    />
                    Prikaži zunanjo razpoložljivost (stranke)
                    <span></span>
                </label>
            </div>
        </div>
        <div class="mf-show-weekend">
            <label class="m-checkbox">
                <input
                    [checked]="guiSettings.filter.showWeekend"
                    (change)="onChangeShowWeekend()"
                    type="checkbox"
                    i18n="@@1a2dce0b-8842-5f3f-86ba-c3ea34596a7f"
                />
                Prikaži vikend
                <span></span>
            </label>
        </div>
        <div class="mf-show-holidays">
            <label class="m-checkbox">
                <input [checked]="guiSettings.filter.showHolidays" (change)="onChangeShowHolidays()" type="checkbox" i18n="@@calendar_showHolidays" />
                Prikaži praznike
                <span></span>
            </label>
        </div>
        <div>
            <label class="m-checkbox">
                <input
                    [checked]="guiSettings.filter.showServicesColor"
                    (change)="onChangeServicesColor()"
                    type="checkbox"
                    i18n="@@app.calendar.settings.view.showServicesColor"
                />
                Prikaži barvo storitve
                <span></span>
            </label>
        </div>
        <div class="mb-2">
            <button
                (click)="changeCalendarTimeSpan()"
                type="button"
                ngbTooltip="Spremeni časovni razpon"
                class="btn btn-secondary w-100 btn-sm"
                i18n-ngbTooltip="@@616433cf6f70e254264f1c2fb0aa9fc9e05ebc48"
            >
                {{ guiSettings.filter.from }} - {{ guiSettings.filter.to }}
            </button>
        </div>
        <div class="btn-group m-btn-group btn-group-sm w-100">
            <button
                (click)="changeCalendarTimeFrequency(5)"
                ngbTooltip="Zmanjšaj prikaz (-5 min)"
                type="button"
                class="btn btn-secondary w-100"
                i18n-ngbTooltip="@@f4bfabb87816af25be1aac9d11b756d2a8037174"
            >
                <i class="la la-search-minus"></i>
            </button>
            <button
                (click)="changeCalendarTimeFrequency(-5)"
                ngbTooltip="Povečaj prikaz (+5 min)"
                type="button"
                class="btn btn-secondary w-100"
                i18n-ngbTooltip="@@49f875dd3b6906fcff8f97bc49c8edac98ec3aef"
            >
                <i class="la la-search-plus"></i>
            </button>
        </div>
    </div>
</div>
